import { collection, getDocs, query, where } from 'firebase/firestore';

import { HomeworkFromDBType } from 'shared/types/notebookTypes';

import { firestore } from '../Common/Firebase';

export const getHomeworks = async (userSubject: string | undefined): Promise<(HomeworkFromDBType | null)[]> => {
  const q = query(collection(firestore, 'homeworks-content-student'), where('subject', '==', userSubject));

  const querySnapshot = await getDocs(q);

  return querySnapshot.docs.map(doc => {
    if (doc.exists()) {
      const ops = JSON.parse(doc.data().content);
      const id = doc.data().id;
      return { ops: ops, id: id };
    } else {
      console.log('No such document!');
      return null;
    }
  });
};
